export default function Footer() {
  const serviceLinks = [
    '物件仲介サービス',
    '収益最適化コンサルティング',
    '運用管理サポート'
  ];

  const companyLinks = [
    '会社概要',
    '代表メッセージ',
    '採用情報'
  ];

  return (
    <footer className="bg-[#2C2C2C] text-white py-20">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-4 gap-12 mb-16">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-white flex items-center justify-center">
                <span className="text-[#1A3A52] text-xl font-bold">V</span>
              </div>
              <span className="text-lg font-serif tracking-wide">
                バケーションレンタル
              </span>
            </div>
            <p className="text-[14px] text-[#CCCCCC] leading-[1.8]">
              信頼と実績で選ばれる
              <br />
              バケーションレンタル
              <br />
              不動産仲介のプロフェッショナル
            </p>
          </div>

          <div>
            <h3 className="text-[14px] font-bold mb-6">サービス</h3>
            <ul className="space-y-4">
              {serviceLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href="#"
                    className="text-[14px] text-[#CCCCCC] hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-[14px] font-bold mb-6">企業情報</h3>
            <ul className="space-y-4">
              {companyLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href="#"
                    className="text-[14px] text-[#CCCCCC] hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-[14px] font-bold mb-6">お問い合わせ</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-[18px] text-[#CCCCCC]" />
                <span className="text-[14px] text-[#CCCCCC]">info@vacation-rental.co.jp</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-[18px] text-[#CCCCCC]" />
                <span className="text-[14px] text-[#CCCCCC]">03-1234-5678</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#444444] pt-8">
          <div className="flex items-center justify-between">
            <p className="text-[12px] text-[#CCCCCC]">
              © 2024 バケーションレンタル株式会社. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[12px] text-[#CCCCCC] hover:text-white transition-colors duration-200 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
